import React from "react";
import { Box, Typography } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import useCommonStyles from "./style";

const TextBlock = ({ classes, title, text }) =>
  text ? (
    <Box className={classes.cbBlock}>
      <Typography className={classes.cbBlockTitle}>{title}</Typography>
      <Typography className={classes.cbBlockText}>{text}</Typography>
    </Box>
  ) : null;

const ListBlock = ({ classes, title, items }) => {
  const list = Array.isArray(items) ? items.filter(Boolean) : [];
  if (!list.length) return null;
  return (
    <Box className={classes.cbBlock}>
      <Typography className={classes.cbBlockTitle}>{title}</Typography>
      <ul className={classes.cbList}>
        {list.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </Box>
  );
};

// Long Chatbot Output Summary (Assessment): the chatbot Comprehensive
// Assessment as a readable summary — subtitle, affected channels, symptoms,
// root causes, prognosis.
const ChatbotSummary = ({ payload }) => {
  const classes = useCommonStyles();

  const p = payload || {};
  const prognosis = p.prognosis || {};
  const prognosisBadge = prognosis.badge || prognosis.sub;
  // A report can exist but be empty (e.g. regenerated from an incomplete
  // assessment) — treat "no meaningful content" the same as no report.
  const hasContent =
    p.subtitle ||
    p.affectedChannel ||
    (Array.isArray(p.presentingSymptoms) && p.presentingSymptoms.length) ||
    (Array.isArray(p.rootCauseBullets) && p.rootCauseBullets.length) ||
    prognosisBadge ||
    p.prognosisIntro;

  if (!hasContent) {
    return (
      <Box className={classes.hiPlaceholder}>
        <InfoOutlinedIcon className={classes.hiPlaceholderIcon} />
        <Typography className={classes.hiPlaceholderNote}>
          No chatbot assessment summary available for this patient yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {payload.subtitle && (
        <Typography className={classes.cbLead}>{payload.subtitle}</Typography>
      )}

      {payload.affectedChannel && (
        <TextBlock
          classes={classes}
          title="Affected Channels (Srotas)"
          text={payload.affectedChannel}
        />
      )}

      <ListBlock
        classes={classes}
        title="Presenting Symptoms"
        items={payload.presentingSymptoms}
      />

      <ListBlock
        classes={classes}
        title="Ayurvedic Root Causes"
        items={payload.rootCauseBullets}
      />

      {(prognosisBadge || payload.prognosisIntro) && (
        <Box className={classes.cbBlock}>
          <Typography className={classes.cbBlockTitle}>Prognosis</Typography>
          {prognosisBadge && (
            <Box mb={payload.prognosisIntro ? 1 : 0}>
              <span className={classes.cbChip}>{prognosisBadge}</span>
            </Box>
          )}
          {payload.prognosisIntro && (
            <Typography className={classes.cbBlockText}>
              {payload.prognosisIntro}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ChatbotSummary;
